const ELASTIC_CONFIG = {
  host: window.aqJobsOptions?.elasticHost || 'https://5d0493d4cacf44dbb8a0b25eefe15970.us-east-2.aws.elastic-cloud.com:443',
  apiKey: window.aqJobsOptions?.elasticAPIKey || 'X1NVQ1E1Z0I2ZkxkWlpmbzBzN1A6QnpkM1dYazRTVjZ3aUZqR0F1dG1NUQ==',
  jobsIndex: window.aqJobsOptions?.elasticJobIndex || 'jobs-north-america',
};

export const elasticPrimaryConfig = {
  host: ELASTIC_CONFIG.host,
  index: ELASTIC_CONFIG.jobsIndex,
  apiKey: ELASTIC_CONFIG.apiKey,
};
